'use client'

import React, { createContext, useContext,useState } from 'react'

type PanelContextType = {
  isDesktopPanelOpen: boolean
  setIsDesktopPanelOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const PanelContext = createContext<PanelContextType | undefined>(undefined)

export function PanelProvider({ children }: { children: React.ReactNode }) {
  const [isDesktopPanelOpen, setIsDesktopPanelOpen] = useState(() => {
    // Initialize from localStorage if available
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('aura-panel-closed')
      return saved !== 'true' // If saved as 'true' (closed), return false (not open)
    }
    return false // Default to closed on server-side
  })

  return (
    <PanelContext.Provider
      value={{ isDesktopPanelOpen, setIsDesktopPanelOpen }}
    >
      {children}
    </PanelContext.Provider>
  )
}

export function usePanel() {
  const context = useContext(PanelContext)
  if (context === undefined) {
    throw new Error('usePanel must be used within a PanelProvider')
  }
  return context
}
